import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';

import { isMobile } from '../../../core/helpers/isMobile';

import ExpandWild from '../../../components/common/expandWild';

const ExpandWildWrapper = observer(() => {
  const { containerConfig } = useMemo(() => {
    return {
      containerConfig: {
        x: isMobile() ? 72 : 324.5,
        y: isMobile() ? 291 : 168,
      },
    };
  }, []);

  return <ExpandWild containerConfig={containerConfig} />;
});

export default ExpandWildWrapper;
